<template>
  <div class="book">
    <div class="container btnP searchDV text-center pt-2">
        
      <button class="btn btn-info btnP" @click="prt()">طباعة</button>
    </div>

    <div class="page2" v-for="itm in lng" :key="itm">
      <div class="subpage">
        <header class="row">
          <div class="col-4 pt-4">
            شركة الصافنات للنقل
          </div>
          <div class="col-4">
            <p class="text-center">بسم الله الرحمن الرحيم</p>
            <p class="text-center"><span> تقرير المسددين للحافلة رقم  </span> <span> {{bus_id}} </span></p>
            <p class="text-center">{{ classyearsN}}</p>
          </div>
          <div class="col-4 text-left">
            <img src="../../../public/static/img/logo.png" alt="" />
          </div>
        </header>
        <div class="bd">
          <table class="table">
            <thead>
              <tr>
                <th>م</th>
                <th>الكود </th>
                <th>الاسم</th>
                <th>قيمة الاشتراك</th>
                <th>المبلغ المدفوع</th>
                <th>الهاتف</th>
                <th> المرحلة</th>
                <th> الجامعة / المدرسة</th>
                <th>بداية العقد </th>
                <th>نهاية العقد  </th>
                
               
              </tr>
            </thead>
            <tbody>
                
              <tr v-for="rw in cunt" :key="rw" >
             
                <td >{{ inx }}</td>
                <td>{{ loadsub[indx].id}}</td> 
                <td>{{ loadsub[indx].name}}</td>
                <td>{{ loadsub[indx].amount}}</td>
                <td class="total">{{ loadsub[indx].paid}}</td>
                <td>{{ loadsub[indx].mob}}</td>
                <td>{{ loadsub[indx].level}}</td>
                <td>{{ loadsub[indx].collage}}</td>
                <td>{{ loadsub[indx].startAt}}</td>
                <td>{{ loadsub[indx].endAt}}</td>
               
                {{
                   addnum(indx, itm) 

                }}
                <!-- <td v-if="addnum()" ></td> -->
              </tr>
              <tr>
                   <td ></td>
                <td></td> 
                <td></td>
                <td><span> المجموع </span></td>
                <td class="total"> <span>{{total }} </span> <span>ريال</span></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <footer class="row">
          <div class="col-4">
            <span>رقم الصفحة </span>
            <span>{{ itm }}</span>
            <span> | </span>
            <span> {{ lng }} </span>
          </div>
          <div class="col-4 "></div>
          <div class="col-4">
            <span>التاريخ</span>
            <span> / </span>
            <span>{{dt}} </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import reportsLayout from "../../layouts/reportsLayout.vue";
import $ from "jquery";
export default {
  name: "depitByBusR",
  data() {
    return {
   
      lng: 0,
      datalng: 0,
      cunt: 10,
      indx: 0,
      kwd: 0,
      dt:'',
      inx:1,
      sst:'',
      ppt:'',
      total:0,
      loadsub:[],
    };
  },
  props:['classyearsID','classyearsN','bus_id'],
  computed: {
    ...mapGetters({
      std: "stdMod/GET_STDALL",
      payment: "payMod/GET_ALLDATA",
      col: "collagesMod/GET_ALLDATA",
      levels: "GET_LEVELS",
    })
  },
 async created() {
    this.$emit("update:layout", reportsLayout);
    await this.LoadData();
    this.loadDate();
    this.reportLoad();
  },
  methods: {
   
    LoadData() {
      
        var name = 0;
        var amount =0;
        var paid= 0;
        var mob=0;
        var depit=0;
        var level='';
        var income=0;
        var stotal=0;
        var collage='';
        var startAt = '';
        var endAt = '';
      
        /*for loop */

        
        /* */
        if(this.bus_id != null){
            var sumT=0;
          const vm = this;
          let list=[];
          var ld= this.std.filter((t)=>t.busCode == this.bus_id  && t.classyears == this.classyearsID);
            $.each(ld, function () {
           sumT = parseFloat(this.AmountSub);
           income = vm.paymt(this.id,this.busCode);
           if(income == sumT){
            name = this.Fname +' '+this.Sname+' '+this.Ffname;
            amount = this.AmountSub;
            paid = income;
            depit = (sumT - income);
           mob = this.mob;
           level = vm.levels.find((t)=>t.id == this.Level_id);
           level = level.nLevel;
           collage = vm.col.find((t)=>t.id == this.Collage_id);
           collage = collage.collageName;
           startAt = this.startSub;
           endAt = this.endSub;
            stotal += sumT;

 list.push({
               "id":this.id,
               "name":name,
               "amount":amount,
               "paid":paid,
               "depit":depit,
               "mob":mob,
               "level":level,
               "collage":collage,
               "startAt":startAt,
               "endAt":endAt,

           });
           }
           });
        this.total = stotal;
        this.loadsub = list;
        } 
        
        
    }
    ,paymt(stdID,busId){
        var payT=0;
           var kk = this.payment.filter((t)=>t.stdID == stdID && t.busID == busId && t.classyears == this.classyearsID);
              $.each(kk, function () {
               payT += parseFloat(this.amount);
            });
            return payT;
    },
    reportLoad() {
      if (this.loadsub != null) {
        this.indx = this.loadsub.length - 1;
        var lln = Math.floor(this.loadsub.length / this.cunt);
        if (lln < 1) {
          this.cunt = this.loadsub.length ;
          this.lng = 1;
        } else {
          this.lng = Math.ceil(this.loadsub.length / this.cunt);
          var ss = this.cunt * lln;
          this.kwd = this.loadsub.length - ss;
        }
       
        //window.print();
      }
    }, addnum: function(indx, itm) {
      
     this.inx += 1; 

    this.indx = this.indx - 1 
    
      if (itm == this.lng) {

        if (this.kwd > 1) {
            
          if (this.indx == this.kwd - 1) {
           
           this.cunt = this.indx;
          }

        } else if(this.kwd == 1) {

          if (this.indx == 1) {
            this.cunt = 1;
          }
          
        }
      }
      /* var chk = this.loadsub[indx].id;
      if(chk == 'undefind'){
      this.indx = chkV;
      } */
    },
    prt() {
      window.print();
    },
    loadDate(){
      const event = new Date();
       const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        }
     this.dt = event.toLocaleDateString('ar-SA', options);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../public/static/css/print.css";
.searchDV {
  height: 50px;
  width: 790px;
  background-color: white;
}
.bd {
  height: 940px;
}
thead{
 background-color: #d4d4d4; 
}
.total{
    background-color: yellow;
}
</style>
